import ChartTypeToggle from "../components/ChartTypeToggle";
import { CHART_TYPE_STORAGE_KEY } from "./constants";

const DoraTimeToRecoveryHeaderActions = () => (
  <ChartTypeToggle storageKey={CHART_TYPE_STORAGE_KEY} />
);

export default DoraTimeToRecoveryHeaderActions;
